<div class="wrap">
  <div class="content">
    <div class="sections">
      <div class="check-box">
        <mat-checkbox [(ngModel)]="tipEnable" (change)="onCheckBoxChange($event)" />
      </div>
      <div class="text">
        <div class="title">Give {{selectedTipPerc}}% to Ketto to keep us afloat</div>
        <div class="sub-title">If you like what we are doing, leave us a tip !</div>
      </div>
    </div>
  </div>
</div>